import { List } from 'immutable';
import { kycCompanyTaxResidencyDocConstants } from 'constants/kyc_company_tax_residency_doc.constants';

export function tax_residency_docs(state = {}, action) {
  switch (action.type) {
    case kycCompanyTaxResidencyDocConstants.TAX_RESIDENCY_DOC_LIST_LOADING:
      return { ...state, items: null, listLoading: true };
    case kycCompanyTaxResidencyDocConstants.TAX_RESIDENCY_DOC_LIST_SUCCESS:
      return { ...state, items: List(action.response), listLoading: false };
    case kycCompanyTaxResidencyDocConstants.TAX_RESIDENCY_DOC_LIST_FAILURE:
      return { ...state, listLoading: false, items: null, listError: action.error };

    case kycCompanyTaxResidencyDocConstants.TAX_RESIDENCY_DOC_CREATE_LOADING:
      return { ...state, createLoading: true };
    case kycCompanyTaxResidencyDocConstants.TAX_RESIDENCY_DOC_CREATE_SUCCESS: {
      const items = state.items ? state.items : List();
      return { ...state, items: items.push(action.response), createLoading: false, createError: null };
    }
    case kycCompanyTaxResidencyDocConstants.TAX_RESIDENCY_DOC_CREATE_FAILURE:
      return { ...state, createLoading: false, createError: action.error };

    case kycCompanyTaxResidencyDocConstants.TAX_RESIDENCY_DOC_EDIT_LOADING:
      return { ...state, editLoading: true };
    case kycCompanyTaxResidencyDocConstants.TAX_RESIDENCY_DOC_EDIT_SUCCESS: {
      if (!state.items) return state;
      const idx = state.items.findIndex(val => val.id == action.response.id);
      if (idx == -1) return state;
      return { ...state, items: state.items.set(idx, action.response), editLoading: false, editError: null };
    }
    case kycCompanyTaxResidencyDocConstants.TAX_RESIDENCY_DOC_EDIT_FAILURE:
      return { ...state, editLoading: false, editError: action.error };

    case kycCompanyTaxResidencyDocConstants.TAX_RESIDENCY_DOC_DELETE_LOADING:
      return { ...state, deleteLoading: true };
    case kycCompanyTaxResidencyDocConstants.TAX_RESIDENCY_DOC_DELETE_SUCCESS: {
      if (!state.items) return state;
      const idx = state.items.findIndex(val => val.id == action.docId);
      if (idx == -1) return state;
      return { ...state, items: state.items.delete(idx), deleteLoading: false };
    }
    case kycCompanyTaxResidencyDocConstants.TAX_RESIDENCY_DOC_DELETE_FAILURE:
      return { ...state, deleteLoading: false, deleteError: action.error };

    case kycCompanyTaxResidencyDocConstants.TAX_RESIDENCY_DOC_ERROR_RELOAD:
      return { ...state, createError: null, editError: null };

    default:
      return state;
  }
}
